import React, { useEffect, useState } from 'react';

function Header({ data }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const networks = data?.social?.map((network) => (
    <li key={network.name}>
      <a 
        href={network.url} 
        target="_blank" 
        rel="noopener noreferrer"
        aria-label={network.name}
      >
        <i className={network.className}></i>
      </a>
    </li>
  ));

  return (
    <header 
      id="home"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.35)), url(${process.env.PUBLIC_URL}/images/header-background.jpeg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center'
      }}
    >
      <nav id="nav-wrap" className={scrolled ? 'opaque' : ''}>
        <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
          Mostrar navegação
        </a>
        <a className="mobile-btn" href="#home" title="Hide navigation">
          Ocultar navegação
        </a>

        <ul id="nav" className="nav">
          <li className="current">
            <a className="smoothscroll" href="#home">Home</a>
          </li>
          <li>
            <a className="smoothscroll" href="#about">About me</a>
          </li>
          <li>
            <a className="smoothscroll" href="#testimonials">Testimonial</a>
          </li>
          <li>
            <a className="smoothscroll" href="#contact">Contact</a>
          </li>
        </ul>
      </nav>

      <div className="row banner">
        <div className="banner-text">
          <h1>Elisabete Monteiro</h1>
          <h3>
            Individual and personalized online private lessons of BRAZILIAN PORTUGUESE to FOREIGNERS. Lessons via Skype with support by whatsapp.
            <br />
            For more information, visit the links below or click <a href="#contact">here</a> to contact me.
          </h3>
          <hr />
          <ul className="social">{networks}</ul>
        </div>
      </div>

      <p className="scrolldown">
        <a href="#about">
          <i className="fa-solid fa-chevron-down"></i>
        </a>
      </p>
    </header>
  );
}

export default Header;
